import React, { useRef, useState } from 'react';
import {
  AutoComplete,
  AutoCompleteChangeEvent,
  AutoCompleteHandle
} from '@progress/kendo-react-dropdowns';
import { Box } from '@mui/material';

type Props = {
  data?: string[];
  value?: string;
  placeholder?: string;
  onChange: (event) => void;
};

const AutoCompleteFilter: React.FC<Props> = ({
  data = [],
  value = '',
  placeholder,
  onChange
}) => {
  const [stateValue, setStateValue] = useState<string>(value);
  const [filteredData, setFilteredData] = useState<string[]>(data);
  const inputRef = useRef<AutoCompleteHandle | null>(null);

  const handleInputChange = (event: AutoCompleteChangeEvent) => {
    const value = event.target.value;
    setStateValue(value);

    if (!value) {
      setFilteredData(data);
      onChange({
        value: '',
        operator: 'contains',
        syntheticEvent: event.syntheticEvent
      });
    } else {
      setFilteredData(
        data.filter((item) => item.toLowerCase().includes(value.toLowerCase()))
      );
    }
  };

  const handleSelect = (event) => {
    const value = event.target.value;
    setStateValue(value);

    onChange({
      value,
      operator: 'contains',
      syntheticEvent: event.syntheticEvent
    });

    if (value.length > 0) {
      handleBlur();
    }
  };

  const handleClearClick = (event) => {
    event.preventDefault();
    setStateValue('');
    setFilteredData(data);

    onChange({
      value: '',
      operator: 'contains',
      syntheticEvent: event
    });
  };

  const handleBlur = () => {
    if (inputRef.current && inputRef.current.element) {
      const inputElement = inputRef.current.element.querySelector('input');
      if (inputElement) {
        inputElement.blur();
      }
    }
  };

  return (
    <Box paddingRight={2}>
      <AutoComplete
        ref={inputRef}
        className="setup-tag-groups-autocomplete-filter"
        data={filteredData}
        onChange={handleInputChange}
        onClose={handleSelect}
        value={stateValue}
        placeholder={placeholder}
      />
      <button
        className="k-button k-button-icon k-clear-button-visible"
        title="Clear"
        hidden={!stateValue}
        onClick={handleClearClick}
      >
        <span className="k-icon k-i-filter-clear" />
      </button>
    </Box>
  );
};

export default AutoCompleteFilter;
